import React from 'react';
import { alpha } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { UI, PAYOUT_PROVIDERS } from '../constants';
import TransferView from '../view/TransferView';

export default function Hero() {
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      <Container
        maxWidth="lg"
        sx={{ position: 'relative', pt: { xs: 5, md: 8 }, pb: { xs: 6, md: 9 } }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: { xs: 4, md: 6 },
            alignItems: 'center',
          }}
        >
          <Box>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{
                display: 'inline-flex',
                px: 1.25,
                py: 0.6,
                borderRadius: 6,
                border: `1px solid ${UI.border}`,
                mb: 2.5,
              }}
            >
              <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: UI.green }} />
              <Typography sx={{ fontSize: 12, color: UI.textMuted }}>
                Live payouts across Somalia
              </Typography>
            </Stack>

            <Typography
              sx={{
                fontSize: { xs: '2.4rem', md: '3.4rem' },
                lineHeight: 1.05,
                fontWeight: 800,
                letterSpacing: '-0.03em',
                color: UI.text,
              }}
            >
              Crypto in.
              <br />
              <Box
                component="span"
                sx={{
                  background: UI.gradientText,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Cash in Somalia
              </Box>{' '}
              out.
            </Typography>

            <Typography
              sx={{
                mt: 2,
                fontSize: { xs: 15, md: 16 },
                color: UI.textMuted,
                maxWidth: 460,
                lineHeight: 1.7,
              }}
            >
              Swap crypto for fiat, pay anyone in Somalia straight from your wallet, or top up your
              exchange balance with cash while you&apos;re on the ground. One rate, shown before you
              confirm.
            </Typography>

            <Stack direction="row" spacing={1.5} sx={{ mt: 3.5 }} flexWrap="wrap" useFlexGap>
              <Button
                component="a"
                href="#how"
                sx={{
                  height: 46,
                  px: 2.5,
                  borderRadius: 6,
                  fontWeight: 700,
                  textTransform: 'none',
                  color: UI.text,
                  border: `1px solid ${UI.borderStrong}`,
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.04)' },
                }}
              >
                See how it works
              </Button>
              <Button
                component="a"
                href="#transfer"
                sx={{
                  height: 46,
                  px: 2.5,
                  borderRadius: 6,
                  fontWeight: 800,
                  textTransform: 'none',
                  color: '#0A0B08',
                  background: UI.gradient,
                  '&:hover': { background: UI.gradient, filter: 'brightness(1.05)' },
                }}
              >
                Start a transfer
              </Button>
            </Stack>

            <Stack direction="row" spacing={1} sx={{ mt: 3 }} flexWrap="wrap" useFlexGap>
              {PAYOUT_PROVIDERS.map((provider) => (
                <Stack
                  key={provider.key}
                  direction="row"
                  alignItems="center"
                  spacing={0.75}
                  sx={{
                    px: 1.5,
                    py: 0.75,
                    borderRadius: 5,
                    border: `1px solid ${alpha(UI.green, 0.25)}`,
                    color: UI.green,
                  }}
                >
                  <Box
                    sx={{
                      width: 18,
                      height: 18,
                      borderRadius: '50%',
                      bgcolor: alpha(UI.green, 0.15),
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 10,
                      fontWeight: 700,
                    }}
                  >
                    {provider.mark}
                  </Box>
                  <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: UI.green }}>
                    {provider.label}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Box>

          <Box id="transfer">
            <TransferView />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
